import { Card, SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

const DealScheduledEventSkeletonCard: FC = () => {
  return (
    <Card>
      <Card.Body className="flex flex-row">
        <SkeletonLoader.Square className="h-[45px] w-[45px] shrink-0 mr-4" />
        <div className="w-full space-y-2">
          <SkeletonLoader.Text className="w-3/4" />
          <SkeletonLoader.Title className="w-1/6" />
          <SkeletonLoader.Text className="w-1/2" />
        </div>
      </Card.Body>
    </Card>
  );
};
const DealScheduledEventsSkeleton: FC = () => {
  return (
    <div className="my-4 space-y-4">
      <DealScheduledEventSkeletonCard />
      <DealScheduledEventSkeletonCard />
      <DealScheduledEventSkeletonCard />
    </div>
  );
};

export default DealScheduledEventsSkeleton;
